import { StoreState } from '../store-interfaces';

export const selectMailchimpAccounts = (state: StoreState) =>
  state.mailchimp.accounts;

export const selectMailchimpAccountsId = (state: StoreState) =>
  state.mailchimp.accountsId;

export const selectMailchimpLists = (state: StoreState) =>
  state.mailchimp.lists;

export const selectMailchimpTotalListItems = (state: StoreState) =>
  state.mailchimp.totalListItems;

export const selectMailchimpListMergeFields = (state: StoreState) =>
  state.mailchimp.listMergeFields;
